import { useState } from "react";
import { Chip } from "primereact/chip";
import { InputText } from "primereact/inputtext";
import PropTypes from "prop-types";
import Label from "./Label";
import { Button } from "primereact/button";
import _ from "lodash";

const Tags = ({
  className = "",
  input,
  label = "",
  meta,
  placeholder = "",
  required = false,
  disabled = false,
  readOnly = false,
  removeOptionsDisabled = false,
  ...rest
}) => {
  if (!removeOptionsDisabled) {
    removeOptionsDisabled = disabled || readOnly;
  }
  const { touched, error } = meta || {};
  const [textValue, setTextValue] = useState("");

  const onAddTags = () => {
    if (input.onChange) {
      let tags = [...(input.value || []), ...textValue.split(",")]
        .map((tag) => _.trim(tag))
        .filter((tag) => tag !== ""); // Filter out empty strings
      tags = _.uniq(tags);
      input.onChange(tags);
      setTextValue("");
    }
  };

  const renderDefaultInput = () => {
    return (
      <InputText
        id={input.name}
        required={required}
        type="text"
        value={textValue}
        disabled={disabled || readOnly}
        invalid={touched && error}
        className={`edexlms-field-input w-full ${className}`}
        placeholder={placeholder}
        onChange={(e) => setTextValue(e.target.value)}
      />
    );
  };

  return (
    <div
      data-testid={`field-${input.name}`}
      className={`edexlms-field text-input ${readOnly ? "readonly" : ""} ${
        disabled ? "disabled" : ""
      } `}
    >
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
        />
      )) ||
        null}
      {(!disabled && (
        <div className="flex flex-row gap-2">
          {renderDefaultInput()}
          <Button type="button" icon="pi pi-plus" onClick={onAddTags} />
        </div>
      )) ||
        null}
      {input.value?.length > 0 && (
        <div className="flex flex-row gap-2" style={{ marginTop: "5px" }}>
          {input.value.map((tag, index) => (
            <Chip
              key={index}
              label={tag}
              className="p-mr-2 p-mb-2"
              removable={!removeOptionsDisabled}
              onRemove={() =>
                input.onChange(input.value.filter((_, i) => i !== index))
              }
            />
          ))}
        </div>
      )}
      {((!input.value || input.value?.length === 0) && disabled && "NA") ||
        null}
    </div>
  );
};

Tags.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Tags;
